import 'tslib';
import React, { useState, useEffect } from 'react';
import '../../../../../services/base/baseDiscoverService.js';
import '../../../../../services/base/baseV3Service.js';
import '../../../../../services/sgtService.js';
import '@analytics/storage-utils';
import 'date-fns/format';
import 'date-fns/secondsToMinutes';
import 'date-fns/isValid';
import 'date-fns/addMinutes';
import 'date-fns';
import 'date-fns-tz';
import { useError } from '../../../../../utils/ErrorProvider.js';
import '../../../../../utils/LoaderProvider.js';
import '../../../../../utils/RefetchProvider.js';
import '../../../../../utils/NotificationProvider.js';
import { getUniqueTimeStampId } from '../../../../../utils/getUniqueId.js';
import '../../../../../utils/ContactProvider.js';
import { useDebounce } from '../../../../../utils/useDebounce.js';
import '../../../../../utils/PolicyProvider.js';
import '../../../../../utils/AnalyticsProvider.js';
import '../../../../../types/AccessDevice.js';
import '../../../../../types/Analytics.js';
import '../../../../../types/CASACommunity.js';
import '../../../../../types/Community.js';
import '../../../../../types/DxSettings.js';
import '../../../../../types/MagicButton.js';
import '../../../../../types/Pannellum.js';
import '../../../../../types/Prospect.js';
import '../../../../../types/ProspectIntelligence.js';
import { NodeLinkType } from '../../../../../types/Space.js';
import '../../../../../types/Tour.js';
import '../../../../../utils/analyticsPlugin.js';
import '../../../../../utils/communityGoogleAnalyticsPlugin.js';
import 'qs';
import '../../../../../utils/cookieUtils.js';
import '../../../../../utils/termsConditionsAgreementsUtils.js';
import '../../../../../services/base/analyticsV2BaseService.js';
import 'axios';
import '../../../../../services/base/internalApiBaseService.js';
import '../../../../../services/base/casaBaseService.js';
import '../../../../../services/scanRequestsService.js';
import '../../../../../services/db/insightsReportsDB.js';
import 'dot-object';
import '../../../../../apis/analytics/useDownloadAnalyticsReports.js';
import { useSpaces } from '../../../../../apis/space/useSpaces.js';
import '../../../../../apis/upload/useSignedURL.js';
import { usePannellumViewer } from '../../../../components/pannellum-viewer/PannellumProvider.js';
import { useTheme, PeekDialogContent, PeekStack, PeekDialogContentText, PeekBox, PeekAutocomplete, PeekTextField } from '@piiqtechnologies/ui-components';
import { getStartNodeId } from '../../../../components/pannellum-viewer/pannellumUtils.js';

const SpaceHotspot = ({ onHotspotCreation }) => {
    var _a;
    const theme = useTheme();
    const { details } = usePannellumViewer();
    const [getSpaces, spaces, spacesLoading, spacesError] = useSpaces();
    const [search, setSearch] = useState();
    const debouncedSearchKey = useDebounce(search, 700);
    const { setError } = useError();
    useEffect(() => {
        if (spacesError === null || spacesError === void 0 ? void 0 : spacesError.message) {
            setError(spacesError === null || spacesError === void 0 ? void 0 : spacesError.message);
        }
    }, [spacesError]);
    useEffect(() => {
        if (details === null || details === void 0 ? void 0 : details.community._id) {
            getSpaces({
                community: {
                    _id: details === null || details === void 0 ? void 0 : details.community._id,
                },
                isVisible: true,
                isComplete: true,
                search: debouncedSearchKey,
            });
        }
    }, [details === null || details === void 0 ? void 0 : details.community._id, debouncedSearchKey]);
    const handleSceneSelection = (event, space) => {
        const nodeLink = {
            _id: getUniqueTimeStampId("hotspot"),
            label: space.unit,
            type: NodeLinkType.Space,
            node: getStartNodeId(space.nodes, space.startNode),
            rotation: {
                pitch: 0,
                yaw: 0,
            },
            spaceId: space._id,
        };
        onHotspotCreation(nodeLink);
    };
    return (React.createElement(PeekDialogContent, null,
        React.createElement(PeekStack, { direction: "column", spacing: 1 },
            React.createElement(PeekDialogContentText, { textAlign: "center", color: "primary" },
                "This Community: ",
                details.community.name),
            React.createElement(PeekDialogContentText, { color: "primary", fontWeight: "fontWeightBold" }, "Select a space to link to"),
            React.createElement(PeekBox, { height: 235 },
                React.createElement(PeekAutocomplete, { freeSolo: false, disablePortal: true, popupIcon: null, options: ((_a = spaces === null || spaces === void 0 ? void 0 : spaces.data) === null || _a === void 0 ? void 0 : _a.filter(({ _id }) => _id !== details._id)) || [], loading: spacesLoading, onChange: handleSceneSelection, getOptionLabel: (option) => option.unit, sx: { "& .MuiInput-root .MuiInput-input": { p: theme.spacing(0.5) } }, open: true, renderInput: (params) => (React.createElement(PeekTextField, Object.assign({}, params, { onChange: (e) => setSearch(e.target.value), placeholder: "Search for a space", variant: "standard", InputProps: Object.assign(Object.assign({}, params.InputProps), { disableUnderline: true }) }))) })))));
};

export { SpaceHotspot, SpaceHotspot as default };
